import React from "react";
import AppTemplate from "../components/Agreement";

const Agreement: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Agreement;
